import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../config/redux/types';
import { TrackPurchaseEvent } from '../../../features/tracking/types';
import useTrackEcommerce from '../../../features/tracking/useTrackEcommerce';
import { BOOKING_CONFIRMATION } from '../../../routes/config/pageTypes';
import { useLegacyApi } from '../../../routes/legacyApiHook';
import { BookingConfirmationState } from '../../../routes/reducers/types';
import BookingConfirmation from '../components/BookingConfirmation';

function buildTrackingIdentifier(
  lang: string | undefined,
  bookingConfirmation: BookingConfirmationState | undefined,
): string | null {
  const bookingInfo = bookingConfirmation?.booking_info;
  if (lang == null || bookingInfo == null) {
    return null;
  }
  return [lang, bookingInfo.accommodation_id, bookingInfo.price].join('-');
}

function buildTrackingEvent(
  bookingConfirmation?: BookingConfirmationState,
): TrackPurchaseEvent | null {
  const bookingInfo = bookingConfirmation?.booking_info;
  if (!bookingInfo) {
    return null;
  }

  return {
    event: 'purchase',
    currency: 'EUR',
    id: bookingInfo.id.toString(),
    transaction_id: bookingInfo.id.toString(),
    value: bookingInfo.price,
    items: [
      {
        id: bookingInfo.accommodation_id.toString(),
        item_id: bookingInfo.accommodation_id.toString(),
        name: bookingInfo.name,
        item_name: bookingInfo.name,
        quantity: 1,
        price: bookingInfo.price,
      },
    ],
  };
}

export default function BookingConfirmationContainer(): JSX.Element | null {
  const { lang } = useParams<'lang'>();
  const { bookingConfirmation } = useSelector((state: RootState) => state.routes);

  useLegacyApi(undefined, BOOKING_CONFIRMATION);

  useTrackEcommerce(
    buildTrackingEvent(bookingConfirmation),
    buildTrackingIdentifier(lang, bookingConfirmation),
  );

  if (!bookingConfirmation) {
    return null;
  }

  return <BookingConfirmation {...bookingConfirmation} />;
}
